/**
 * @format
 * @flow
 */
import React from 'react';

// import * as RT from '../../constants/Routing'
// import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router';
import Modal from '../../../components/Common/Modal';
import * as Actions from '../../../actions/Task';
import Template from '../../../components/Template/AfterLoginTemplate';
// import * as RT from '../../../constants/Routing'
import TaskCard from '../../../components/Parts/TaskCard';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      tasks: this.props.Task.oldTask.Items,
      searchDate: '2019年7月'
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount = () => {
    // console.log('過去タスク一覧', this.props)
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getOldTask(enterpriseId, token, 1, 18);
  };

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps = next => {
    if (!this.state.loaded && next.Task.oldTaskLoaded !== this.state.loaded) {
      this.setState({ loaded: true });
    }
  };

  componentWillUnmount = () => {
    this.props.resetOldTasks();
  };

  _toPaging = page => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    this.props.getOldTask(enterpriseId, token, page, 18);
  };

  _renderPaging = () => {
    const pageCount = this.props.Task.oldTask.page_count;
    if (pageCount > 1) {
      const nextPage = this.props.Task.oldTask.next_pages;
      const prevPage = this.props.Task.oldTask.prev_pages;
      const currentPage = this.props.Task.oldTask.next_pages - 1;

      const pageList = [...Array(pageCount)].map((_, i) => {
        const isActivePage = currentPage === i + 1 || (nextPage === 0 && i + 1 === pageCount);
        const classList = isActivePage ? 'active page-item' : 'page-item';

        let action;
        if (!isActivePage) {
          action = () => this._toPaging(i + 1);
        }

        return (
          <li className={classList}>
            <span className="page-link" onClick={action}>
              {i + 1}
            </span>
          </li>
        );
      });

      let prevAction;
      if (prevPage !== 0) {
        prevAction = () => this._toPaging(prevPage);
      }

      let nextAction;
      if (nextPage !== 0) {
        nextAction = () => this._toPaging(nextPage);
      }

      return (
        <div className="paging-wrap">
          <ul className="pagination">
            <li className="page-item">
              <span className="page-link prev-link" onClick={prevAction}>
                «
              </span>
            </li>
            {pageList}
            <li className="page-item">
              <span className="page-link next-link" onClick={nextAction}>
                »
              </span>
            </li>
          </ul>
        </div>
      );
    }
  };

  render = () => {
    // console.log(this.props)
    const tasks = this.props.Task.oldTask.Items;
    let tasksView;
    if (tasks === undefined) {
      tasksView = null;
    } else {
      tasksView = tasks.map(task => {
        return (
          <div className="col-4">
            <TaskCard task={task} key={task.taskId} taskOld />
          </div>
        );
      });
    }

    return (
      <Template>
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle={this.props.App.modalHeader}
          // eslint-disable-next-line no-console
          okClickHandler={() => console.log('aaa')}
          okText="ログインページへ"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.modalText}
        </Modal>
        <div className="">
          <h2>過去の案件</h2>
          <div>
            <div style={{ textAlign: 'right' }} />
          </div>
          <div className="flex-row">
            {(() => {
              if (this.state.loaded) {
                if (tasks !== undefined && tasks.length > 0) {
                  return tasksView;
                }
                return (
                  <div>
                    <p>まだ登録したタスクはありません。</p>
                  </div>
                );
              }
              return (
                <div>
                  <p>読み込み中...</p>
                </div>
              );
            })()}
            {(() => {
              if (this.state.loaded) {
                return this._renderPaging();
              }
            })()}
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
